import { mapGetters } from 'vuex';
// import { sizeEmitter } from 'helpers/layout.manager';

import { closest, rAF } from '../utils';

import isElement from 'lodash/isElement';

const TOP_POSITION = 0;

export default {
   name: 'Sticky',
   props: {
      position: {
         type: String, // top|bottom
         default: 'top'
      },
      scrollable: {
      },
      mode: {
         type: String, // standard|always|none
         default: () => 'standard'
      }
   },
   data() {
      return {
         isSticked: false
      };
   },
   computed: {
      scrollableElement() {
         const se = document.scrollingElement;
         if (!this.scrollable) {
            return se;
         }
         return isElement(this.scrollable) ? this.scrollable : closest(this.$el, this.scrollable) || window;
      },
      isTopSticky() {
         return this.position === 'top';
      },
      ...mapGetters(['getCurrentWidth'])
   },
   methods: {
      _stickIfNeeded() {
         const rect = this.$el.getBoundingClientRect();

         let need2stick = false;

         if ( this.mode === 'none' ) {
            need2stick = false;
         } else if ( this.mode === 'always' ) {
            need2stick = true;
         } else if ( this.isTopSticky ) {
            need2stick = rect.top < TOP_POSITION;
         } else {
            const ch = window.innerHeight;// document.body.clientHeight;
            need2stick = rect.bottom > ch;
         }

         if (need2stick !== this.isSticked) {
            if (need2stick) {
               this._stick();
            } else {
               this._unstick();
            }
         } else if (need2stick) {
            this._restoreWidth();
         }
      },
      _stick() {
         this.$refs.placeholder.style.height = `${this.$refs.slot.clientHeight}px`;
         this.isSticked = true;
         this.$nextTick(this._restoreWidth);
      },
      _unstick() {
         this.$refs.slot.style.width = '';

         this.isSticked = false;
         this.$nextTick(() => this.$refs.placeholder.style.height = '');
      },
      _onResize() {
         // wait dialog listeners
         this.$nextTick(() => {
            // wait rerender dialog
            this.$nextTick(this._restoreWidth);
         });
      },
      _restoreWidth() {
         const width = this.$refs.placeholder.offsetWidth;
         if (width) {
            this.$refs.slot.style.width = `${width}px`;
         }
      }
   },
   watch: {
      mode() {
         this.$nextTick(this._stickIfNeeded);
      },
      getCurrentWidth() {
         this._onResize();
      }
   },
   mounted() {
      this.scrollableElement.addEventListener('scroll', this._stickIfNeeded);
      this.$parent.$on('deep:updated', this._stickIfNeeded);
      rAF(this._stickIfNeeded);
   },
   beforeDestroy() {
      this.scrollableElement.removeEventListener('scroll', this._stickIfNeeded);
      this.$parent.$off('deep:updated', this._stickIfNeeded);
   }
};
